// W-0829 — Modal Incluir/Editar Tipo de Resultado de Atendimento (Formik + Yup).
// Campos: Descricao (texto, MaxLen 100) + Paga (radio S/N). Em edição, Codigo é read-only
// (gerado pelo backend via MAX+1 lockado — nunca editável). SEM campo Cobranca (fixado 'S' no
// backend — ADR-004). Mensagens literais do Delphi.

import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { RESULTADO_ATEND_PAGA_OPCOES } from '~/constant';

const schemaTipo = Yup.object().shape({
  descricao: Yup.string()
    .trim()
    .required('Necessário informar Descrição.')
    .max(100, 'Necessário informar Descrição.'),
  paga: Yup.string()
    .required('Necessário informar Pagamento de Comissão.')
    .oneOf(['S', 'N'], 'Necessário informar Pagamento de Comissão.'),
});

const ModalFormTipo = ({ show, tipo, onConfirmar, onCancelar }) => {
  const edicao = !!(tipo && tipo.codigo != null);
  const initialValues = {
    descricao: tipo ? tipo.descricao || '' : '',
    paga: tipo ? tipo.paga || '' : '',
  };

  return (
    <Modal show={show} onHide={onCancelar} centered>
      <Modal.Header closeButton>
        <Modal.Title>{edicao ? 'Editar Tipo' : 'Incluir Tipo'}</Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={schemaTipo}
        onSubmit={(valores) => {
          if (edicao) {
            onConfirmar({ codigo: tipo.codigo, descricao: valores.descricao.trim(), paga: valores.paga });
          } else {
            onConfirmar({ descricao: valores.descricao.trim(), paga: valores.paga });
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Body>
              {edicao && (
                <Form.Group>
                  <Form.Label className="small mb-1">Código</Form.Label>
                  <Form.Control size="sm" type="text" value={tipo.codigo} readOnly disabled />
                </Form.Group>
              )}
              <Form.Group>
                <Form.Label className="small mb-1">Descrição</Form.Label>
                <Form.Control
                  size="sm"
                  name="descricao"
                  type="text"
                  maxLength={100}
                  value={values.descricao}
                  onChange={handleChange}
                  isInvalid={touched.descricao && !!errors.descricao}
                />
                {touched.descricao && errors.descricao && (
                  <Form.Text className="text-danger">{errors.descricao}</Form.Text>
                )}
              </Form.Group>
              <Form.Group>
                <Form.Label className="small mb-1 d-block">Paga Comissão ao Cobrador</Form.Label>
                {RESULTADO_ATEND_PAGA_OPCOES.map((opt) => (
                  <Form.Check
                    inline
                    key={opt.value}
                    type="radio"
                    id={`ra-paga-${opt.value}`}
                    name="paga"
                    label={opt.label}
                    value={opt.value}
                    checked={values.paga === opt.value}
                    onChange={handleChange}
                  />
                ))}
                {touched.paga && errors.paga && (
                  <Form.Text className="text-danger d-block">{errors.paga}</Form.Text>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={onCancelar}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Confirmar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalFormTipo;
